import { StorageSubscriptionManager } from "../subscriptions";
export class UserPrivateMetadataRepository {
    subscriptionManager = new StorageSubscriptionManager();
    /**
     * Subscribe to changes in user private metadata.
     */
    subscribeForUser(userUid, onChange) {
        return this.subscriptionManager.addSubscription(userUid, onChange);
    }
    /**
     * Unsubscribe from changes in user private metadata.
     */
    unsubscribeForUser(userUid, handlerUid) {
        return this.subscriptionManager.unsubscribe(userUid, handlerUid);
    }
    /**
     * Helper for notifying listeners.
     */
    notifyOnChange(userUid, change) {
        return this.subscriptionManager.notify(userUid, change);
    }
}
//# sourceMappingURL=UserPrivateMetadataRepository.js.map